// extracted by mini-css-extract-plugin
export default {"lander":"styles_lander__FyAss","link":"styles_link__SIQmv","english":"styles_english__3aiIF","korean":"styles_korean__w7pdw"};